module.exports = __webpack_public_path__ + "static/media/construction.bb010139.svg";